import React from 'react'
import { Download } from 'lucide-react'

import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@/components/ui/table'

import {
  FILE_NAME_COLUMN,
  FILE_SIZE_COLUMN,
  FILE_LINK_COLUMN,
  FILE_NAME_COLUMN_FRIENDLY,
  FILE_SIZE_COLUMN_FRIENDLY,
  FILE_LINK_COLUMN_FRIENDLY
} from '../../stores/order'

export default function DownloadableFiles({ files }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-10">#</TableHead>
          <TableHead>{FILE_NAME_COLUMN_FRIENDLY}</TableHead>
          <TableHead>{FILE_SIZE_COLUMN_FRIENDLY}</TableHead>
          <TableHead>{FILE_LINK_COLUMN_FRIENDLY}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {files.map((file, idx) => (
          <TableRow key={file[FILE_LINK_COLUMN] || idx}>
            <TableCell className="text-muted-foreground">{idx + 1}</TableCell>
            <TableCell className="break-all">{file[FILE_NAME_COLUMN]}</TableCell>
            <TableCell>{file[FILE_SIZE_COLUMN]}</TableCell>
            <TableCell>
              <a
                href={file[FILE_LINK_COLUMN]}
                className="inline-flex items-center gap-1 text-primary hover:underline"
              >
                <Download className="h-4 w-4" />
                Download
              </a>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
